/**
 * Safely parse a JSONB `target_ids` value that may have been double-serialized.
 *
 * When target_ids was stored via `JSON.stringify()` into a JSONB column, PostgreSQL
 * stored it as a JSONB string (e.g. `"[]"`) rather than a JSONB array (`[]`).
 * On read, these come back as plain strings instead of arrays.
 *
 * This function handles both the correct (array) and corrupted (string) forms.
 */
export function parseTargetIds(raw: unknown): string[] {
  if (Array.isArray(raw)) return raw as string[];
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
    } catch {
      // Not valid JSON — return empty
    }
  }
  return [];
}
